import type { PortalApplication } from '../../../model/portalModels';
import { isValidWorkflowPageRoute } from '@jukun/platform-sdk/workflow';
import { resolveTrustedAppUrl } from '../../../runtime/wujieLoader';
import type { PortalWorkItemDetail } from '../model/myTasks';

const TENANT_APPLICATION_PROCESS_ID = 'ADMIN_TENANT_APPLICATION_V2';

export function isBuiltInTenantApplication(detail: PortalWorkItemDetail) {
  return detail.flowPageContext.applicationCode === 'ADMIN'
    && detail.flowPageContext.processId === TENANT_APPLICATION_PROCESS_ID;
}

export function resolveWorkItemPagePath(detail: PortalWorkItemDetail) {
  if (!isValidWorkflowPageRoute(detail.pageRoute)) {
    throw new Error('Workflow 工作项页面路由不合法');
  }
  return detail.pageRoute;
}

export function resolveWorkItemTargetUrl(
  application: PortalApplication,
  detail: PortalWorkItemDetail,
  currentHref = window.location.href,
) {
  return resolveTrustedAppUrl(
    application,
    `${application.entry.basePath}${resolveWorkItemPagePath(detail)}`,
    currentHref,
  );
}
